import { Button, Empty, Flex, Spin, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'

import { useTreatmentServiceGetSidaCaseEndpoint } from 'src/api/queries'
import { GetSidaCaseResponse } from 'src/api/requests'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

export const SidaCaseTab = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const navigate = useNavigate()

  const { data: sidaCase, isLoading } = useTreatmentServiceGetSidaCaseEndpoint(
    { personId: String(id) },
    [id],
    { enabled: !!id, retry: false }
  )

  if (isLoading) return <Spin />

  if (!sidaCase?.id) {
    return <Empty description={t('sida_notification.no_case')} />
  }

  const columns: ColumnsType<GetSidaCaseResponse> = [
    {
      key: 'fullName',
      title: t('sida_notification.full_name'),
      render: (_, record) => record.form?.fullName || '-'
    },
    {
      key: 'idnp',
      title: t('sida_notification.idnp'),
      render: (_, record) => record.form?.idnp || '-'
    },
    {
      key: 'aidsStageDate',
      title: t('sida_notification.sida_stage_date'),
      render: (_, record) =>
        record.form?.aidsStageEstablishedDate
          ? dayjs(record.form.aidsStageEstablishedDate).format(
              dayMonthYearFormatWithDot
            )
          : '-'
    },
    {
      key: 'arvTreatment',
      title: t('sida_notification.arv_treatment_at_diagnosis'),
      render: (_, record) =>
        record.form?.hasArvTreatmentAtDiagnosis
          ? t('sida_notification.yes')
          : t('sida_notification.no')
    },
    {
      key: 'actions',
      render: () => (
        <Button
          type="link"
          onClick={() =>
            navigate(paths.patients.sidaNotification.details(String(id)))
          }
        >
          {t('common.details')}
        </Button>
      )
    }
  ]

  return (
    <Flex vertical gap={16}>
      <Table
        rowKey="id"
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={[sidaCase]}
        pagination={false}
      />
    </Flex>
  )
}
